import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/xs/service/ui-manager' );

import { Injectable } from '@angular/core';
import { XsIdentityInterface } from '../../interfaces/identify.interface';
import { Constants } from '@src/app/commons/Constants';
import { BehaviorSubject, Subject } from 'rxjs';

import * as _ from 'lodash';

import { Dataset, FourDService, TransformGroup } from '4d-mapper';
import { MapService } from '@src/app/commons/map.service';
import { XsEventListenerInterface } from '../../interfaces/event-listener.interface';
import { XsApplicationEventsService } from '../events/application-events.service';
import { debounceTime } from 'rxjs/operators';
import { StreamDataService } from '@src/app/v2/commons/stream-data.service';
import { MapDataService } from '@src/app/v2/commons/map-data.service';
import { FileDataService } from '@src/app/v2/commons/file-data.service';


@Injectable({
  providedIn: 'root'
})
export class XsIncomingDataService implements XsIdentityInterface, XsEventListenerInterface {

  __ID = null;
  __EVENTS = null;

  debug:boolean = Constants.debug_off;
  debugCounter:number = 0;

  // core data
  length:number = 0;

  // current batch's max number
  lengthPhotosBatched:number = 0;

  // current photos in the queue
  lengthPhotos:number = 0;
  lengthPhotosUploading:number = 0;
  lengthPhotosProcessing:number = 0;

  // percentage calculated lengths
  percentFactor:number = 0;
  percentDone:number = 0;
  percentWorking:number = 0;

  items: Dataset[] = [];
  photos: Dataset[] = [];
  untyped: Dataset[] = [];

  _log:any = {};

  state:any = {};

  // subject for incoming data queries
  private incomingData$ = new Subject<any>();
  private _incomingData$ = this.incomingData$.asObservable().pipe(debounceTime(1000));

  __log( key:string, s:any ) {
    const now = Math.round(performance.now());
    const item = s.item;
    const event = s.event;
    const id = item ? item.id : 'null';
    const name = item ? item.name : 'null';
    const mode = s.args && s.args.mode ? s.args.mode : 'null';
    const socket = s.args && s.args.socket ? s.args.socket : 'null';
    const status = s.item ? s.item.status : 'null';
    const incomplete = s.item ? s.item.incomplete : 'null';
    const entry = now + ' ['+event+'] m=['+mode+'] so=['+socket+'] st=['+status+'] i=['+incomplete+']';
    if ( !this._log['all'] ) {
      this._log['all'] = {};
    }
    if ( !this._log['all'][id] ) {
      this._log['all'][id] = [];
      this._log['all'][id].push(now + ' {'+name+'} ['+id+'] ---------' + '('+key+')');
    }
    if ( !this._log[key] ) {
      this._log[key] = {};
    }
    if ( !this._log[key][id] ) {
      this._log[key][id] = [];
      this._log[key][id].push(now + ' {'+name+'} ['+id+'] ---------' );
    }
    this._log['all'][id].push(entry + '('+key+')');
    this._log[key][id].push(entry);
  }

  __isDatasetForCurrentScene(item:any) {
    if ( !this.mapService && !this.mapService.scene && !item && !item.folder ) {
      return false;
    }
    return item.folder.id == this.mapService.scene.folder.id;
  }

  constructor ( public applicationEvents: XsApplicationEventsService, public fourD: FourDService, public mapService: MapService, 
    private streams:StreamDataService, private mapData: MapDataService, private fileData: FileDataService
  ) {
    
    DEBUG.log ( '/xs/service/incoming-data' );
    this.__ID = XsIdentityInterface.__init(this);
    this.__EVENTS = XsEventListenerInterface.__init(this);
    if ( this.debug ) { console.log ( "%c incomingDataManager CONSTRUCTOR() ", Constants._yellow, this.debug ); }


    // this.add( new Dataset(this.fourD.V).set({ "id":99999999990, "name": "First test file", "__state":"transform", "__test": true }));
    // this.add( new Dataset(this.fourD.V).set({ "id":99999999991, "name": "Second test file", "__state":"file", "__test": true }));

    this.incomingData$.pipe(debounceTime(2000)).subscribe(s => {

      
    });

    
    

    // A jpeg will throw this several times, befin, mid end upload beging and end processing
    this.streams.fileEvents.subscribe(s => {

      if ( this.__isDatasetForCurrentScene(s.item) ) {

        // console.log('## %c [file] %c for current scene', Constants._purple, Constants._white, s );

        this.__log('file',s);

        if ( s.event == 'processing_finished' && s.item.dataType.uid == 'photo' ) {
          // this.remove(s.item);
        } else if ( s.event == 'ADD' ) {
          // console.log('## %c [file] %c for current scene ADD', Constants._purple, Constants._white, s );
          this.add(s.item);
        }

      } else {
        // console.log('## %c [file] %c for other scene', Constants._purple, Constants._white, s, s.item.folder.id, this.mapService.scene.folder.id );
      }

    });

    /*
    this.streams.folderEvents.subscribe(s => {
      console.log('## [folder]', s );
    });

    this.streams.sceneEvents.subscribe(s => {
      console.log('## [scene]', s, this._log );
    });

    this.streams.annotationEvents.subscribe(s => {
      console.log('## [annotation]', s );
    });

    this.mapData.sceneLayers.events.subscribe(s => {
      console.log('## [layer-mapdata]', s );
    });

    this.mapData.scene.events.subscribe(s => {
      console.log('## [scene-mapdata]', s );
    });
    */

    /*
    this.fileData.processingItems.events.subscribe(s => {
      console.log('## [process]', s );
    });

    
    this.fileData.uploadingFiles.events.subscribe(s => {
      console.log('## [upload]', s );
    });

    this.fileData.uploadingQueue.events.subscribe(s => {
      console.log('## [upload-queue]', s );
    });
    */

    // listen for uploads happening
    this.fourD.uploadsRunningObservable.subscribe( s => {
      // console.log('## %c [upload-obs] %c ', Constants._purple, Constants._white, s );
      this.uploadingUpdate(s);
    });

    // listen to sockets for task_updates
    // this.fourD.onSocketCommand('task_update').subscribe(s => {
    //   console.log('## %c [task-update-socket] %c ', Constants._purple, Constants._white, s );
    //   this.processingUpdate(s);
    // });

    this.fourD.runningTasksObservable.subscribe( s => {
      // console.log('## %c [running-obs] %c', Constants._purple, Constants._white, s );
      this.processingUpdate(s);
    });

  }

  _updateLengths() {

    // const tests = ['test1.jpg','test2.JPG','bongo.yalla','some.jp2','test3.jpeg','test4.Jpg'];
    const arr = ['.jpg','.jpeg'];

    const findStr = (arr, str) => arr.some(e => str.toLowerCase().includes(e.toLowerCase()) )

    this.photos = this.items.filter( d => {
      return ( d.dataType && d.dataType.uid == 'photo' ) || ( !d.dataType && findStr(arr,d.name) ); 
    });
    this.length = this.items.length;
    this.lengthPhotos = this.photos.length;
    this.lengthPhotosUploading = 0;
    this.lengthPhotosProcessing = 0;
    this.photos.forEach ( p => {
      p['__name_based_photo'] = true;
      if ( this.state[p.id] ) {
        if ( this.state[p.id] == 'process-working'  || this.state[p.id] == 'process-ready' ) {
          // console.log('## photo ['+p.id+'] state [process]',p.id,this.state[p.id]);
          this.lengthPhotosProcessing++;
        } else if ( this.state[p.id] == 'upload-working' ) {
          // console.log('## photo ['+p.id+'] state',p.id,this.state[p.id]);
          this.lengthPhotosUploading++;
        } else {
          // console.log('## photo ['+p.id+'] state ??',p.id,this.state[p.id]);
        }
      } else {
        // console.log('## photo ['+p.id+'] NO state',p.id,this.state[p.id]);
      }
    });

    

    if ( this.lengthPhotos > this.lengthPhotosBatched ) {
      this.lengthPhotosBatched = this.lengthPhotos;
    }

    if ( this.lengthPhotos == 0 ) {
      this.lengthPhotosBatched = 0;
    }

    this.percentFactor = this.lengthPhotosBatched ? 100 / this.lengthPhotosBatched: 1;

    let sofar = this.lengthPhotosBatched - this.lengthPhotos;

    this.percentDone = (this.percentFactor * ( sofar ));
    this.percentWorking = (this.percentFactor * ( sofar + this.lengthPhotosProcessing ));

  }

  _getItem( id:number ) {
    return this.items.find( f => f.id == id );
  }

  _getItemIdFromEvent(s:any) {
    let ret = null;
    if ( s.task ) {
      let check:number = s.task.dataset ? s.task.dataset.id : ''+parseInt(s.task.uid);
      ret = this.items.find ( f => f.id == check );
    }
    if ( !ret && s.dataset ) {
      ret = this.items.find ( f => f.id == s.dataset.id );
    }
    return ret ? ret.id : null;
  }

  _getStateFromEvent(s:any) {
    let ret = 'unknown';
    if ( s.event ) {
      if ( s.event == 'start' || s.event == 'add' ) {
        ret = 'working';
      } else if ( s.event == 'finished' || s.event == 'remove' ) {
        ret = 'ready';
      } else {
        ret = s.event;
      }
    } else if ( s.status ) {
      ret = s.status == 'started' ? 'working' : s.status;
    }
    return ret;
  }



  /* The main API */

  // add an item to our list of incoming files
  add( dataset:Dataset = null, log:boolean = true ) {
    if ( dataset ) {
      const find = this.items.find( f => f.id == dataset.id );
      if ( find ) {
        // if ( log ) { console.log('## %c add() %c already here', Constants._orange, Constants._white, dataset); }
      } else {
        this.items.push(dataset);

        // possible states: 'upload-working', 'upload-ready', 'process-working', 'process-ready', 'process-error'

        this.state[dataset.id] = dataset.incomplete ? 'upload-working' : 'upload-ready';

        // if ( log ) { console.log('## %c add() %c Added',Constants._orange, Constants._white, dataset); }
      }
      this._updateLengths();
    }
  }

  // add a bunch of items
  addAll ( datasets:Dataset[] = null ) {
    if ( datasets && datasets.length ) {
      // console.log('## %c addAll() %c ',Constants._orange, Constants._white, datasets);
      datasets.forEach ( ds => this.add(ds,false));
    }
  }

  // process an incoming file (start an ad-hoc processing job)
  process ( dataset:Dataset = null, transformType:any = null, service:any = null, dialog:any = null ) {

    let datatypeId = null;

    // no incoming transform data type? But we know there are some? Pick from the top ...
    if ( !transformType && dataset.dataType._adhocTransforms.length ) {
      datatypeId = dataset.dataType._adhocTransforms[0].id;
    } else if ( transformType ) {
      datatypeId = transformType.id;
    }

    // find the type
    let type = dataset.dataType._adhocTransforms.find ( f => f.id == datatypeId);

    if ( this.debug ) { console.log('## %c process() %c ',Constants._orange, Constants._white, dataset, datatypeId, type); }

    if ( !type ) {
      throw ( 'No transform datatype found');
    }

    this.state[dataset.id] = 'process-working';

    service.startAdHoc(dialog,dataset,type,true).subscribe(
      success => {
        if ( this.debug ) { console.log('## incomingData process success', success ); }
        this.state[dataset.id] = 'process-ready';
      },
      error => {
        if ( this.debug ) { console.log('## incomingData process error', error ); }
        this.state[dataset.id] = 'process-error';
      }
    );
  }

  // cancel an uploading file
  cancel ( dataset:Dataset = null ) {
    if ( this.debug ) { console.log('## incomingData cancel',dataset); }
    this.remove(dataset);
  }

  // remove an incoming file (and make sure we don't add it to our list again in the future)
  remove ( dataset:Dataset = null ) {
    if ( this.debug ) { console.log('## %c remove %c ',Constants._orange, Constants._white, dataset); }
    if ( dataset ) {
      dataset['__incoming_dismissed'] = true;
      dataset.saveObservable().subscribe();
      this.items = this.items.filter(ds => ds.id !== dataset.id);
      this._updateLengths();
      // if ( this.debug ) { console.log('## incomingData Removed',dataset); }
    }
  }

  // remove a list of things
  removeAll ( datasets:Dataset[] = null ) {
    if ( datasets && datasets.length ) {
      datasets.forEach ( ds => this.remove(ds));
    }
  }

  // create a new spanking list from querying files attached to a scene folder
  populateFromScene( scene:TransformGroup = null ) {

    if ( !scene ) {
      scene = this.mapService.scene;
    }

    const from = Date.now();
    const time = 14*24*60*60*1000; // fortnight
    const me = Date.now() - time;
    // const ts = 1632115478038;
    // console.log('## %c populateFromScene() %c ', Constants._orange, Constants._white, me, new Date(from), new Date(me), scene, scene.folder );

    // first fetch all files in the scene folder within the last 14 days
    this.fourD.V.searchByObject(Dataset).equals('folder', scene.folder).greaterThan('dateUpdated', me ).sortBy('dateUpdated', true).limit(878).queryObservable().subscribe(value => {
      
      // find those with no transforms?
      let find = value.items.filter(v => ( !v['__incoming_dismissed']) && ( v.dataType && v.dataType._adhocTransforms && v.dataType._adhocTransforms.length ) && (!v.transformIds || !v.transformIds.length || !v.transformIds[0] ) );
      if ( this.debug ) { console.log('## %c populateFromScene() %c Populate', Constants._orange, Constants._white, value.items, find ); }
      this.addAll(find);

    }, error => {
      if ( this.debug ) { console.log('## populateFromScene() ERROR',error); }
    });
  }

  _incomingUpdate( key:string, s:any) {

    const id:number = this._getItemIdFromEvent(s);
    const item:Dataset = this._getItem(id);

    if ( item ) { 
      item.fetchObservable().subscribe(); 
    } else {
      if ( this.debug ) { console.log('## %c incoming ['+key+'] %c error ', Constants._blue, Constants._red, key, s, id, typeof id, item ); }
      return;
    }

    this.state[id] = key + '-' + this._getStateFromEvent(s);

    if ( s.task && s.task.dataset ) {
      s.task.event = s.event;
      s.task.status = s.status;
      s.task.item = s.task.dataset;
      this.__log(key,s.task);
    }
    

    if ( this.debug ) { console.log('## %c incoming ['+key+'] %c ', Constants._blue, Constants._white, id, this._getStateFromEvent(s), s ); }

    this._updateLengths();

    return item;

  }

  // listen out for uploading updates
  uploadingUpdate(s:any) {
    this._incomingUpdate('upload',s);
  }

  // listen out for job updates
  jobUpdate(s:any) {
    this._incomingUpdate('job',s);
  }

  // listen out for processing updates
  processingUpdate(s:any) {

    let item = this._incomingUpdate('process',s);

    // is it finished? Then remove from our list
    if ( item && this.state[item.id] == 'process-ready' ) {

      // if not a photo (more specifically; if it's a zip that's unpacked other files), re-query for incoming files

      // console.log('## incomingData PROCESS finished', s );

      item['__auto_zoom_to'] = true;
      this.remove(item);

    }
  }



}
